import React from 'react';
import { useState, useEffect } from 'react';
import { getComments, savecomment } from '../../../common/apiService'
import moment from 'moment'
import { HiPaperAirplane } from 'react-icons/hi'
import { toast } from 'react-toastify';
import { FaSpinner } from 'react-icons/fa';


export default function Comments({ onSelectLanguage, plaza_id, case_id, setComments }) {
    const [commentList, setCommentList] = useState([]);
    const [caseid, setCaseId] = useState("");
    const [plazaid, setPlazaid] = useState("");
    const [commentLoader, setCommentLoader] = useState(false);


    useEffect(() => {

    if(case_id!==null && case_id!==""){
        setComments([]);
        setCaseId(case_id);
        setPlazaid(plaza_id);
        setCommentList([]);
        document.getElementById("comment").value = ""

        getComments(case_id).then(res => {
            setCommentList(res.data || []);
        }).catch(err => {
        });

        const form = document.getElementById('form');
        form.addEventListener('focusin', (event) => {
            onSelectLanguage(true);
        });

        form.addEventListener('focusout', (event) => {
            onSelectLanguage(false);
        });
        }
        // eslint-disable-next-line
    }, [case_id])

    const keyDownEvent = (evt) => {
        if(commentLoader) return;
        if (evt.key === 'Enter') {
            if (evt.currentTarget.value.length > 7) {
                const jsonData = {
                    caseId: caseid,
                    comment: document.getElementById("comment").value,
                    plazaId: Array.isArray(plazaid) ? plazaid.join(",") : plazaid
                }
                setCommentLoader(true);
                savecomment(jsonData).then(() => {
                    getComments(caseid).then(res => {
                setCommentLoader(false);
                        setCommentList([]);
                        setCommentList(res.data || []);
                        setComments(res.data || []);
                        document.getElementById("comment").value = ""
                        var objDiv = document.getElementById("commentscrolldiv");
                        objDiv.scrollTop = objDiv.scrollHeight;
                    }).catch(err => {
                    });
                });
            } else {
                toast.warn("Comment must contain at least eight characters")
            }
        }
    }

    return (
        <>
            <p style={{ borderBottom: '2px dashed lightgray', marginTop: 10 }}></p>
            <span className="comments">Comments:</span><br />
            <div className="scrollcomment" id="commentscrolldiv">
                {
                    commentList.map((e, index) => {
                        return (
                            <div className="commentbox"><span>{e.createdBy}</span> <span className="maker">{e.roles}</span>
                                <span className="date"> {moment(e.creationDate).format('DD MMM YYYY dddd hh:mm:ss')} </span><br />
                                <span className="vehcileinfo">{e.comment}</span>
                            </div>
                        )
                    })
                }

            </div>
            <div style={{ position: 'absolute', bottom: 0, width: '100%' }}>
                <br /> <form id="form" onSubmit={e => { e.preventDefault(); }} style={{ position: 'relative' }}>
                    <input type="text" id="comment" autoComplete="off" placeholder="Enter your comments here" onKeyDown={keyDownEvent} maxLength="300" style={{ fontSize: '15px', color: '#343333', backgroundColor: '#F8F7F7', padding: 10, width: '100%', height: '45px', border: '1px solid #E6E6E6', outline: "none" }} />
                    {commentLoader ?  <FaSpinner icon="spinner" spin className = "spinner comment-spinner"/> :<HiPaperAirplane className="rightCommentArrow" />}
                </form>
            </div>
        </>

    )
}
